import axios from 'axios';
import {Message} from 'element-ui';
import { getCookie } from '@/assets/utils/cookie.js';
axios.defaults.withCredentials = true;
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers["Ticket"] = getCookie("ticket");
axios.interceptors.request.use(config => {
    // 表示在配置中的设置头消息的字段Authorization为从本地获取的token值
    // config.headers.originalUrl = window.location.href.trim();
    return config;
});


axios.interceptors.response.use(res => {
    // 对响应数据做些什么
    // 用户未登录
    return res.data;
}, err => {
    // 对响应错误做些什么
    // console.log('err', err); 
    return Promise.resolve(err);
});

export default axios;